import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCompareInputTab } from "../store/components/Insights.slice";

function useHasReportData() {
    const dispatch = useDispatch();
    const [hasReportData, setHasReportData] = useState(false);
    const {
        generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData, generateGrid
    } = useSelector((state) => state.reports);

    useEffect(() => {
        const value = !!(generalMarketCategoriesData.length
            || audienceSpecificCategoriesData.length
            || categoryDeepDiveData.length
            || generateGrid.length);
        setHasReportData(value);
        if (!value) {
            dispatch(setCompareInputTab("audience"));
        }
    }, [generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData, generateGrid]);

    return hasReportData;
}

export default useHasReportData;
